import { cur } from '../lib/units';
import { Trash2 } from 'lucide-react';
import { MAT_UNITS, layerName, unitLabel, f2 } from '../lib/excavation';
import { eur } from '../lib/license';
import DecIn from './DecIn';

const r3 = (n) => Math.round(n * 1000) / 1000;

export function NumIn({ value, auto, onChange, scale = 1, testid, step = '0.01', label }) {
  const shown = value === null || value === undefined || value === '' ? '' : r3(value * scale);
  return (
    <label className="pit-num">
      {label && <span>{label}</span>}
      <DecIn data-testid={testid} value={shown} placeholder={auto == null ? '' : String(r3(auto * scale)).replace('.', ',')} className={shown !== '' && auto != null ? 'overridden' : ''}
        onNum={(n) => onChange(n == null ? null : n / scale)} />
    </label>
  );
}

function PriceIn({ t, row, onPrice, testid }) {
  const units = MAT_UNITS[row.mat] || MAT_UNITS.custom;
  return (
    <label className="pit-num pit-price">
      <span>{t.pitColPrice}</span>
      <span className="row">
        <DecIn data-testid={`${testid}-price`} value={row.price ?? ''} placeholder={`${cur()}`} onNum={(n) => onPrice({ price: n })} />
        <select data-testid={`${testid}-unit`} value={row.unit} onChange={(e) => onPrice({ unit: e.target.value })}>
          {units.map((u) => <option key={u} value={u}>{`${cur()}/${unitLabel(u)}`}</option>)}
        </select>
      </span>
    </label>
  );
}

export default function PitLayerCard({ t, row, thick, qtyVal, onQty, onDens, onPrice, onRemove, onName, extra }) {
  const testid = `pit-layer-${row.key}`;
  return (
    <div className={`pit-layer pit-layer-${row.mat}`} data-testid={testid}>
      <div className="pit-layer-head">
        {onName ? <input className="pit-layer-name" data-testid={`${testid}-name`} value={row.name || ''} placeholder={t.pitLayerName} onChange={(e) => onName(e.target.value)} /> : extra ? <span className="pit-surf-label">{t.pitSurface}</span> : <b>{layerName(t, row)}</b>}
        {extra}
        {onRemove && <button className="icon-btn danger" data-testid={`${testid}-remove`} onClick={onRemove}><Trash2 size={14} /></button>}
      </div>
      <div className="pit-layer-grid">
        {thick}
        <NumIn label="m³" testid={`${testid}-m3`} value={qtyVal ?? null} auto={row.autoM3} onChange={onQty} />
        <NumIn label={t.pitColDens} testid={`${testid}-dens`} value={row.density} step="0.1" onChange={onDens} />
        <div className="pit-num pit-out"><span>t</span><b data-testid={`${testid}-t`}>{f2(row.t, t.locale)}</b></div>
        <PriceIn t={t} row={row} onPrice={onPrice} testid={testid} />
        <div className="pit-num pit-out"><span>{t.pitColCost}</span><b data-testid={`${testid}-cost`}>{row.cost != null ? eur(row.cost, t.locale) : '–'}</b></div>
      </div>
    </div>
  );
}
